import React, { isValidElement, type JSX, type MouseEvent } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogTitleProps,
} from "@mui/material";
import {styled} from "@mui/material/styles";

const DialogActionsGrey = styled(DialogActions)(() => ({theme}) => ({
  backgroundColor: theme.palette.grey[100]
}));

interface SimpleConfirmationDialogProps {
  body: string | JSX.Element;
  onClose: () => void;
  onConfirm: (event: MouseEvent<HTMLButtonElement>) => void;
  open: boolean;
  title: string | JSX.Element;
  titleProps?: Partial<DialogTitleProps>;
}

const SimpleConfirmationDialog = (
  {
    open = false,
    onClose,
    onConfirm,
    title,
    body,
    titleProps = {variant: 'h6'}
  }: SimpleConfirmationDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={'ss-confirm-title'}
      aria-describedby={'ss-confirm-description'}
    >
      <DialogTitle id={'ss-confirm-title'} {...titleProps}>{title}</DialogTitle>
      <DialogContent id={'ss-confirm-description'}>
        {isValidElement(body) ? <>{body}</>
          : <DialogContentText>{body}</DialogContentText>
        }
      </DialogContent>
      <DialogActionsGrey>
        <Button color={'primary'} onClick={onClose}>
          Cancel
        </Button>
        <Button color={'primary'} type={'submit'} onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActionsGrey>
    </Dialog>
  );
};

export default SimpleConfirmationDialog;
